import React, { useState, useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import TopNav from "../../commonUI/TopHeader/TopHeader";
import { SearchIcon, SendIcon } from "../../commonUI/Icons/SvgIcon";
import ReactSelect from "react-select";
import FilterContainer from "../../commonUI/SearchFilterBar/FilterContainer";
import Pagination from "../../commonUI/Pagination/Pagination";
import { Drawer,Box } from "@mui/material";
import SendPushNotification from "./SendPushNotification";

const PushNotifications = ({ userDetails }) => {
  const [state, setState] = React.useState({
    right: false,
  });
  const [currentView, setCurrentView] = useState(null);

  const [searchValue, setSearchValue] = useState("");
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("any");
  const [recipientFilter, setRecipientFilter] = useState("any");
  const [categoryFilter, setCategoryFilter] = useState("any");
  const [cityFilter, setCityFilter] = useState("any");
  const [dateRange, setDateRange] = useState("anytime");
  const [pageSize, setPageSize] = useState(15);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [inputValue, setInputValue] = useState(1);
  const [selectedSendPushNotification, setSelectedSendPushNotification] = useState(null);


  const toggleDrawer =
    (anchor, open, view = null, sendPushNotification = null) =>
    (event) => {
      if (
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });

      if (open) {
        setCurrentView(view);
        if (sendPushNotification) {
          setSelectedSendPushNotification(sendPushNotification);
        } else {
          setSelectedSendPushNotification(null);
        }
      }
    };


  const list = (anchor) => (
    <Box
      sx={{ width: 600 }}
      role="presentation"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <SendPushNotification
        view={currentView}
        sendPushNotification={selectedSendPushNotification}
        onClose={toggleDrawer(anchor, false)}
      />
    </Box>
  );


  const selectStyles = useMemo(
    () => ({
      control: (provided) => ({
        ...provided,
        minHeight: "40px",
        height: "40px",
        minWidth: "150px",
        width: "150px",
        padding: "0",
        boxShadow: "none",
        "&:focus-visible": {
          borderColor: "#000000",
          boxShadow: "0 0 0 2px #FFFFFF, 0 0 0 4px #000000",
          outline: "none",
        },
      }),
      valueContainer: (provided) => ({
        ...provided,
        height: "40px",
        padding: "0 8px",
        display: "flex",
        alignItems: "center",
      }),
      input: (provided) => ({
        ...provided,
        margin: "0",
        padding: "0",
      }),
      indicatorsContainer: (provided) => ({
        ...provided,
        height: "40px",
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
          ? "#f1f5f9"
          : state.isFocused
          ? "#f1f5f9"
          : null,
        color: "#333",
        "&:hover": {
          backgroundColor: "#f1f5f9",
        },
      }),
      indicatorSeparator: (provided) => ({
        ...provided,
        display: "none",
      }),
    }),
    []
  );
  // Static data matching the image
  const pushNotificationsData = [
    {
      id: 1,
      sentAt: {
        date: "11 Jul 25",
        time: "03:30",
      },
      status: "Sending",
      sentTo: "Drivers",
      category: "All Drivers",
      city: "All Cities",
      notification: {
        title: "App Update Available",
        message:
          "Please update your app to the latest version for new features and improvements.",
      },
      deeplink: "Quotes > Accepted",
      delivered: 1200,
      taps: {
        percentage: "0.00%",
        count: "(0)",
      },
    },
    {
      id: 2,
      sentAt: {
        date: "10 Jul 25",
        time: "14:30",
      },
      status: "Completed",
      sentTo: "Clients",
      category: "All Clients",
      city: "—",
      notification: {
        title: "Summer Discount Available",
        message: "Use code SUMMER25 for 25% off your next booking!",
      },
      deeplink: "Bookings > Upcoming",
      delivered: 3500,
      taps: {
        percentage: "3.63%",
        count: "(127)",
      },
    },
    {
      id: 3,
      sentAt: {
        date: "9 Jul 25",
        time: "10:15",
      },
      status: "Completed",
      sentTo: "Drivers",
      category: "Active",
      city: "London",
      notification: {
        title: "New Jobs Available",
        message:
          "Several new jobs have been posted in your area. Check them out now!",
      },
      deeplink: "Jobs > New Jobs",
      delivered: 450,
      taps: {
        percentage: "21.78%",
        count: "(98)",
      },
    },
    {
      id: 4,
      sentAt: {
        date: "8 Jul 25",
        time: "16:45",
      },
      status: "Completed",
      sentTo: "Clients",
      category: "First timers",
      city: "Birmingham",
      notification: {
        title: "Welcome to Man & Van",
        message: "Thank you for joining! Here are some tips to get started.",
      },
      deeplink: "Account > Edit profile",
      delivered: 120,
      taps: {
        percentage: "70.83%",
        count: "(85)",
      },
    },
    {
      id: 5,
      sentAt: {
        date: "7 Jul 25",
        time: "09:00",
      },
      status: "Failed",
      sentTo: "Drivers",
      category: "Idle",
      city: "Leeds",
      notification: {
        title: "Increase Your Earnings",
        message:
          "We haven't seen you active lately. There are many jobs waiting for you!",
      },
      deeplink: "Account > Invoices",
      delivered: 200,
      taps: {
        percentage: "22.50%",
        count: "(45)",
      },
    },
    {
      id: 6,
      sentAt: {
        date: "6 Jul 25",
        time: "11:30",
      },
      status: "Completed",
      sentTo: "Clients",
      category: "Completed jobs",
      city: "All Cities",
      notification: {
        title: "How was your experience?",
        message: "We hope you enjoyed our service. Please leave a review!",
      },
      deeplink: "Account > Settings",
      delivered: 850,
      taps: {
        percentage: "37.65%",
        count: "(320)",
      },
    },
    {
      id: 7,
      sentAt: {
        date: "5 Jul 25",
        time: "15:20",
      },
      status: "Sending",
      sentTo: "Drivers",
      category: "Zero Jobs",
      city: "Glasgow",
      notification: {
        title: "Start Your Journey",
        message:
          "Complete your profile to start receiving job offers in your area.",
      },
      deeplink: "Quotes > Accepted",
      delivered: 75,
      taps: {
        percentage: "56.00%",
        count: "(42)",
      },
    },
    {
      id: 8,
      sentAt: {
        date: "4 Jul 25",
        time: "13:10",
      },
      status: "Completed",
      sentTo: "Clients",
      category: "Repeat clients",
      city: "—",
      notification: {
        title: "Loyalty Reward",
        message:
          "As a valued customer, enjoy a special 15% discount on your next booking.",
      },
      deeplink: "Quotes > Accepted",
      delivered: 1250,
      taps: {
        percentage: "34.40%",
        count: "(430)",
      },
    },
  ];

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    const inputValue = type === "checkbox" ? checked : value;

    if (name === "search") {
      setSearchValue(inputValue);
    } else if (name === "filter") {
      setSearch("");
      setSearchValue(null);
      setFilter(inputValue);
      setPage(1);
    }
  };

  const searchPushNotifications = useCallback(() => {
    setSearch(searchValue);
    setFilter(searchValue === "" ? "active" : null);
    setPage(1);
  }, [searchValue]);

  const handleReset = () => {
    setSearchValue("");
    setStatusFilter("any");
    setRecipientFilter("any");
    setCategoryFilter("any");
    setCityFilter("any");
    setDateRange("anytime");
    setSearchValue("");
    setSearch("");
  };

  const statusOptions = [
    { value: "any", label: "Any" },
    { value: "client", label: "Client" },
    { value: "driver", label: "Driver" },
    { value: "admin", label: "Admin" },
  ];

  const selectedStatusOption = statusOptions.find(
    (option) => option.value === statusFilter
  );

  const recipientOptions = [
    { value: "any", label: "Any" },
    { value: "client", label: "Client" },
    { value: "driver", label: "Driver" },
  ];

  const categoryOptions = [
    { value: "any", label: "Any" },
    { value: "client", label: "Client" },
    { value: "driver", label: "Driver" },
    { value: "admin", label: "Admin" },
  ];

  const selectedCategoryOption = categoryOptions.find(
    (option) => option.value === categoryFilter
  );

  const cityOptions = [
    { value: "any", label: "Any" },
    { value: "client", label: "Client" },
    { value: "driver", label: "Driver" },
    { value: "admin", label: "Admin" },
  ];

  const selectedCityOption = cityOptions.find(
    (option) => option.value === cityFilter
  );

  const selectedRecipientOption = recipientOptions.find(
    (option) => option.value === recipientFilter
  );

 

  const tableHeader = () => {
    return (
      <thead>
        <tr>
          <th>Sent at</th>
          <th>Status</th>
          <th>Sent to</th>
          <th>Category</th>
          <th>City</th>
          <th>Notification</th>
          <th>Deeplink</th>
          <th>Delivered</th>
          <th>Taps</th>
        </tr>
      </thead>
    );
  };

  const renderPushNotificationItem = (pushNotificationsData, index) => {
    return (
      <tr key={index}>
        <td>
          {pushNotificationsData?.sentAt?.date}
          <br />
          {pushNotificationsData?.sentAt?.time}
        </td>
        <td>
          {" "}
          <span
            className={`badge ${getStatusBadgeClass(
              pushNotificationsData?.status
            )}`}
          >
            {pushNotificationsData?.status}
          </span>
        </td>
        <td>{pushNotificationsData?.sentTo}</td>
        <td>{pushNotificationsData?.category}</td>
        <td>{pushNotificationsData?.city}</td>
        <td>{pushNotificationsData?.notification?.title} <br />
          {pushNotificationsData?.notification?.message}
        </td>
        <td>{pushNotificationsData?.deeplink}</td>
        <td>
          {pushNotificationsData?.delivered} <br />
          {pushNotificationsData?.taps?.percentage}
        </td>
        <td>{pushNotificationsData?.sentAt?.date} <br />
          {pushNotificationsData?.sentAt?.time}
        </td>
      </tr>
    );
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "Sending":
        return "badge-warning";
      case "Completed":
        return "badge-success";
      case "Failed":
        return "badge-danger";
      default:
        return "badge-primary";
    }
  };
  return (
    <>
        <TopNav title="Push Notifications" />
          {["right"].map((anchor) => (
            <React.Fragment key={anchor}>
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center g-8"
                onClick={toggleDrawer(anchor, true, "create")}
              >
                <SendIcon />
                Send Push Notification
              </button>
              <Drawer
                anchor={anchor}
                open={state[anchor]}
                onClose={toggleDrawer(anchor, false)}
                ModalProps={{
                  BackdropProps: {
                    style: { backgroundColor: "rgba(0, 0, 0, 0.2)" },
                  },
                }}
                sx={{
                  boxShadow: "none",
                  "& .MuiDrawer-paper": { boxShadow: "none" },
                }}
              >
                {list(anchor)}
              </Drawer>
            </React.Fragment>
          ))}
      

      <div className="global-body">
        <div className="global-body-container">
          <div className="mb-24 filter-container">
            <div className="lh-1">
              <label htmlFor="search" className="form-label">
                Search
              </label>
              <div className="search-box">
                <input
                  type="text"
                  value={searchValue || ""}
                  onChange={handleInputChange}
                  name="search"
                  className="search-input"
                  placeholder="Search..."
                  id="search"
                  onKeyDown={(e) =>
                    e.key === "Enter" && searchPushNotifications()
                  }
                />
                <SearchIcon />
              </div>
            </div>
            <div className="lh-1">
              <label htmlFor="sender" className="form-label">
                Status
              </label>

              <ReactSelect
                id="status"
                name="status"
                isSearchable={false}
                classNamePrefix="custom-select"
                placeholder="Select Status"
                options={statusOptions}
                value={selectedStatusOption}
                onChange={(selectedOption) => {
                  setStatusFilter(
                    selectedOption ? selectedOption.value : "all"
                  );
                }}
                className="react-select-container"
                styles={selectStyles}
              />
            </div>
            <div className="lh-1">
              <label htmlFor="sender" className="form-label">
                Recipient{" "}
              </label>

              <ReactSelect
                id="recipient"
                name="recipient"
                isSearchable={false}
                classNamePrefix="custom-select"
                placeholder="Select Recipient"
                options={recipientOptions}
                value={selectedRecipientOption}
                onChange={(selectedOption) => {
                  setRecipientFilter(
                    selectedOption ? selectedOption.value : "all"
                  );
                }}
                className="react-select-container"
                styles={selectStyles}
              />
            </div>{" "}
            <div className="lh-1">
              <label htmlFor="sender" className="form-label">
                Category
              </label>

              <ReactSelect
                id="category"
                name="category"
                isSearchable={false}
                classNamePrefix="custom-select"
                placeholder="Select Category"
                options={categoryOptions}
                value={selectedCategoryOption}
                onChange={(selectedOption) => {
                  setCategoryFilter(
                    selectedOption ? selectedOption.value : "all"
                  );
                }}
                className="react-select-container"
                styles={selectStyles}
              />
            </div>{" "}
            <div className="lh-1">
              <label htmlFor="sender" className="form-label">
                City
              </label>

              <ReactSelect
                id="city"
                name="city"
                isSearchable={false}
                classNamePrefix="custom-select"
                placeholder="Select City"
                options={cityOptions}
                value={selectedCityOption}
                onChange={(selectedOption) => {
                  setCityFilter(selectedOption ? selectedOption.value : "all");
                }}
                className="react-select-container"
                styles={selectStyles}
              />
            </div>
            {/* Original FilterContainer Reset */}
            <FilterContainer onReset={handleReset} />
          </div>

          {/* Table Header */}
          <div className="table-responsive">
            <table className="table clientTable">
              {tableHeader()}

              {pushNotificationsData?.length > 0 ? (
                pushNotificationsData?.map(renderPushNotificationItem)
              ) : (
                <div className="no-conversations">
                  <p>No conversations found</p>
                </div>
              )}
            </table>
          </div>

          <Pagination
            pageSize={pageSize}
            totalPages={totalPages}
            page={page}
            setPage={setPage}
            inputValue={inputValue}
            setInputValue={setInputValue}
            setPageSize={setPageSize}
          />
        </div>
      </div>
    </>
  );
};

PushNotifications.propTypes = {
  userDetails: PropTypes.object.isRequired,
};

export default PushNotifications;
